<template>
	<modal name="look-settings" :width="300" :height="400">
		<div id="look-settings-modal">
			<h1>{{ $t('lookSettings.title') }}</h1>
			<IconTimes class="close-modal" @click.native="$modal.hide('look-settings')" />
			<div class="switcher">
				<div :class="{ active: !nightMode }" @click="switchDayMode">{{ $t('lookSettings.lightMode') }}</div>
				<div :class="{ active: nightMode }" @click="switchNightMode">{{ $t('lookSettings.darkMode') }}</div>
			</div>

		</div>
	</modal>
</template>

<script>
	import { mapState } from "vuex";
	import IconTimes from "@/components/icons/IconTimes";
	import Vue from "vue";

	export default {
		components: {
			IconTimes
		},
		computed: {
			...mapState([ "currentUser", "nightMode" ]),
		},
		methods: {
			switchNightMode() {
				localStorage.setItem("nightMode", true);
				this.$store.commit("setNightMode", true);
				Vue.nextTick(() => {
					document.dispatchEvent(new Event("ProcessChords"));
				});
			},
			switchDayMode() {
				localStorage.setItem("nightMode", false);
				this.$store.commit("setNightMode", false);
				Vue.nextTick(() => {
					document.dispatchEvent(new Event("ProcessChords"));
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	#look-settings-modal {
		width: 100%;
		height: 100%;
		background-color: #264653;
		color: rgba(255, 255, 255, 0.8);
		font-weight: 300;

		.close-modal {
			fill: white;
			width: 20px;
			opacity: 0.5;
			position: absolute;
			top: 20px;
			right: 20px;
			cursor: pointer;

			&:hover {
				opacity: 1;
			}
		}

		button.payment-button {
			font-weight: 100;
			margin: 5px 20px 15px 20px;
			padding: 0 20px;
			border: 0;
			font-size: 1em;
			line-height: 40px;
			background-color: #ef904e;
			color: rgba(255, 255, 255, 0.75);
			cursor: pointer;
			border-radius: 4px;
			width: 260px;

			&:hover {
				background-color: #d07a46;
			}

			&:focus {
				outline: none;
			}

			.icon-share {
				width: 21px;
				float: left;
				margin: 3px 0 -3px 0;
			}
		}

		.switcher {
			line-height: 50px;
			display: flex;
			justify-content: center;
			align-items: stretch;
			align-content: stretch;
			width: 260px;
			margin: 5px 20px 15px 20px;
			cursor: pointer;

			> div {
				width: 180px;
				text-align: center;
				background-color: #233842;

				&.active {
					background-color: #e59253;
					border-radius: 2px;
				}

				&:first-child {
					border-bottom-left-radius: 2px;
					border-top-left-radius: 2px;
				}

				&:last-child {
					border-bottom-right-radius: 2px;
					border-top-right-radius: 2px;
				}
			}
		}

		h1 {
			margin: 0;
			padding: 20px;
			font-size: 1.4em;
			font-weight: 100;
		}

		p {
			margin: 0 20px 20px 20px;

			a {
				color: rgb(233,196,106);
				text-decoration: underline;

				&:hover {
					color: rgb(211, 177, 97);
				}
			}
		}
	}
</style>
